import React, { useState, useEffect } from 'react';
import TrueViewTable from './TrueViewTable';
import './App.css';

function App() {
  const [selectedMonth, setSelectedMonth] = useState<string>('');
  const [selectedYear, setSelectedYear] = useState<string>('');
  const [monthLoading, setMonthLoading] = useState(false);

  const handleMonthChange = (month: string) => {
    setSelectedMonth(month);
    setMonthLoading(true);
    setTimeout(() => setMonthLoading(false), 100);
  };

  const handleYearChange = (year: string) => {
    setSelectedYear(year);
    setMonthLoading(true);
    setTimeout(() => setMonthLoading(false), 100);
  };

  const handleGoBack = () => {
    setSelectedMonth('');
    setSelectedYear('');
  };

  return (
    <TrueViewTable 
      onGoBack={handleGoBack}
    />
  );
}

export default App;
